import { Component } from 'react';

export default class Modal extends Component {
  constructor(props) {
    super(props);

    this.handleKeydown = this.handleKeydown.bind(this);
  }

  componentDidMount() {
    this.refs.modal.style.marginTop = -this.refs.modal.offsetHeight / 2 + 'px';
    this.refs.modal.style.top = '50%';
    document.addEventListener('keydown', this.handleKeydown);
    document.body.style.overflow = 'hidden';
  }

  handleKeydown(event) {
    if (event.which === 27) this.toggleModal(event);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
    document.body.style.overflow = 'auto';
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/index.js